import React from 'react';
import { Outlet, useNavigate } from 'react-router';
import { isAuthenticated, useAuth } from '../../teal-react/utils/token';
import MainNav from './MainNav';

const MainLayout = ({ login_required }: { login_required?: boolean }) => {
  const [show, setShow] = React.useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();

  const restricted = login_required && !isAuthenticated();

  React.useEffect(() => {
    if (restricted) {
      navigate('/auth');
    }
    setShow(!login_required || (login_required && isAuthenticated()));
    // eslint-disable-next-line
  }, [login_required, user]);

  if (!show) {
    return null;
  }

  const cs = restricted ? 'content' : 'content_padded';
  return (
    <React.Fragment>
      {login_required && isAuthenticated() ? <MainNav /> : null}
      <div className={cs}>
        <Outlet />
      </div>
    </React.Fragment>
  );
};

export default MainLayout;
